/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 発症タイプ
 */
export type RequestSummaryOnsetTypeEnum =
  (typeof RequestSummaryOnsetTypeEnum)[keyof typeof RequestSummaryOnsetTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RequestSummaryOnsetTypeEnum = {
  ESTIMATED: 'ESTIMATED',
  CONFIRMED: 'CONFIRMED',
  UNKNOWN: 'UNKNOWN',
} as const;
